import { RegionId, TmRegionResponse } from '@business/entities/tm/TmRegionResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { RegionFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditRegionModal/RegionForm';
import { CategoryId } from '@business/entities/tm';
import { CategoryRegionProviderPriorityForm } from '@modules/settings/SettingsPage/Components/BillingTab/Tabs/CategoryTab/ManageProviderPriorityOverlay/ManageProviderPriorityOverlay';

export function fetchRegions() {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions`);
}

export function fetchRegionsMap() {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions/map`);
}

export function fetchRegion(id: RegionId) {
  return Endpoint.get<TmRegionResponse>(`@gc/regions/region/${id}`);
}

export function createRegion(data: RegionFormData) {
  return Endpoint.post<TmRegionResponse>(`@gc/regions`, { data });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function updateRegion(id: RegionId, data: RegionFormData, changeNote: string) {
  return Endpoint.patch<TmRegionResponse>(`@gc/regions/${id}`, { data: { ...data, changeNote } });
}

export function deleteRegion(id: RegionId, changeNote: string) {
  return Endpoint.delete<void>(`@gc/regions/${id}`, { data: { changeNote } });
}

export function fetchCategoryServiceProviders(categoryId: CategoryId) {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions/by-category/${categoryId}`);
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function saveProviderPriorities(data: CategoryRegionProviderPriorityForm, changeNote: string) {
  return Endpoint.post<void>(`@gc/regions/update-priorities`, { data: { ...data, changeNote } });
}
